import JsonLd from 'marketplace-ui-common/components/elements/JsonLd';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import { Paths } from '../constants/paths';
import { getFullPublicUrl } from '../utils/urls';
import { useSearchResultsQuery } from './hooks/useSearchResultsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsPageStructuredData() {
  var _data$result$cards;
  const {
    data
  } = useSearchResultsQuery();
  const item = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [...((_data$result$cards = data === null || data === void 0 ? void 0 : data.result.cards) !== null && _data$result$cards !== void 0 ? _data$result$cards : []).map((element, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': getFullPublicUrl(Paths.LISTING_DETAILS.replace(':listingSlug', element.slug || '')),
        name: element.listingName
      }
    }))]
  };
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx(JsonLd, {
      item: item
    })
  });
}